export default "__VITE_ASSET__BVIWgQ9b__";